// src/config/featureFlags.ts

declare global {
  interface Window {
    _env_?: any;
  }
}

const env = window._env_ || {};

// Handle boolean safely (because Helm may inject string)
export const Analytics_Enabled =
  env.Analytics_Enabled === true || env.Analytics_Enabled === 'true';

export const auroraLauchPointUrl = env.auroraLauchPointUrl;
export const ManageEvidenceRefreshInterval = env.ManageEvidenceRefreshInterval;

export const cspDevMode =
  env.Csp_DevMode === true || env.Csp_DevMode === 'true';
export const Qualtrics_Identifier = env.Qualtrics_Identifier;

// src/config.ts
const baseProductionUrl = '/';
const baseDevUrl = 'https://localhost:7163/';
//use this link to access Dev1
//  const baseDevUrl = 'https://aurora-dev1.consiliotest.com/';

const isProduction = process.env.NODE_ENV === 'production';
const apiBaseUrl = isProduction ? baseProductionUrl : baseDevUrl;
const config = {
  API_BASE_URL: apiBaseUrl + 'ux-api',
  API_MW_BASE_URL: apiBaseUrl + 'mw-api',
  API_AUTH_MODE: 'bff-token-mediator',
  API_VERSION: 'v1',
  PROJECT_TRACKER_URL:
    'https://consilio.service-now.com/x/nsllc/smartflow-project-tracker/',
  BUDGET_TRACKER_URL:
    'https://case.consilio.com/#/central-reports/budget-tracker',
  LAUNCHPOINT_BASE_URL: apiBaseUrl,
  // 'http://launchpoint-service.us2kd2w90.k8d.consiliotest.com',
  USER_IDLE_TIMEOUT_SEC: 30 * 60, //[30m] -- unit in milliseconds
  USER_IDLE_GRACEPERIOD_SEC: 3 * 60, // [3m] -- unit in seconds
  USER_LOGOUT_POPUP_SEC: 180, // [3m]
  USER_LAST_ACTIVITY_TIMEFRAME_BEFORE_LOGOUT_SEC: 1800, // [30m]
  USER_ACTIVITY_INTERVAL_CHECK_MILISEC: 15000, //  [15s]
  MAINTENANCE_STATUS_POLL_MS: 15000,
};

export default config;
